import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { useAuth } from "../../components/authContext";
import "./Receipt.css";

interface Item {
  label: string;
  price: number;
}

interface Props {
  receiptId?: string; // Optional receipt ID
  store?: string;
  items?: Item[];
  tax?: number;
  total?: number;
}

const ReceiptPreview: React.FC<Props> = ({
  receiptId,
  store: initialStore = "Your Store",
  items: initialItems = [],
  tax: initialTax = 0,
  total: initialTotal = 0,
}) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(!!receiptId);
  const [store, setStore] = useState(initialStore);
  const [items, setItems] = useState<Item[]>(initialItems);
  const [tax, setTax] = useState(initialTax);
  const total =
    initialItems.reduce((sum, item) => sum + item.price, 0) + initialTax;

  useEffect(() => {
    const fetch = async () => {
      if (!user || !receiptId) return;

      const ref = doc(db, `users/${user.uid}/purchases`, receiptId);
      const snapshot = await getDoc(ref);

      if (snapshot.exists()) {
        const data = snapshot.data();
        setStore(data.store || "Your Store");
        setItems(data.items || []);
        setTax(data.tax || 0);
      }
      setLoading(false);
    };

    fetch();
  }, [user, receiptId]);

  const subtotal = items.reduce((sum, item) => sum + item.price, 0);

  if (loading) return <p>Loading preview...</p>;

  return (
    <div className="receipt-container">
      <div className="receipt-header">{store}</div>

      {items.map((item, idx) => (
        <div key={idx} className="receipt-line">
          <span>{item.label}</span>
          <span>${item.price.toFixed(2)}</span>
        </div>
      ))}

      <div className="receipt-divider" />

      <div className="receipt-line">
        <strong>Subtotal</strong>
        <span>${subtotal.toFixed(2)}</span>
      </div>
      <div className="receipt-line">
        <strong>Tax</strong>
        <span>${tax.toFixed(2)}</span>
      </div>
      <div className="receipt-line">
        <strong>Total</strong>
        <span>${total.toFixed(2)}</span>
      </div>

      <div className="receipt-footer">Thank you for your purchase!</div>
    </div>
  );
};

export default ReceiptPreview;
